export default () => {
  const tabletSize = window.matchMedia("only screen and (min-width : 768px)");

  $('.subscribe').on('click', function(){
    $(this).toggleClass('active');

    if($(this).hasClass('active')) {
      $(this).html('<i class="fas fa-envelope-open"></i> Estás suscrito a este autor');
      $('.subscribe-modal').show(100).css('display', 'flex');;
    } else {
      $(this).html('<i class="far fa-envelope-open"></i> Suscríbete a mis artículos');
      $('.subscribe-modal').hide(200);
    }

  });

  $('.view-more').on('click', function(){
    if($('.description-more').hasClass('active')) {
      $('.description-more').removeClass('active');
      $('.view-more').html('Ver más');
    }else {
      $('.description-more').addClass('active');
      $('.view-more').html('Ver menos');
    }
  });

  $('.subscribe-modal').on('click', function(){
    $(this).hide(200);
  });


  $('.see-articles').on('click', function(){
    const articlesPosition = $("#authorarticles").offset().top - 140;
    $('html, body').animate({
      scrollTop: articlesPosition
    }, 1000);
  });


  $('.subscribe-articles').on('click', function(){
    $(this).toggleClass('issubscribed');

    if($(this).hasClass('issubscribed')) {
      $(this).html('Estás suscrito a este autor');
    } else {
      $(this).html('Recíbelos por email');
    }
  });
}
